import "./Footer.css";
import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import LinkMui from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import FacebookIcon from '../../../libraries/Icons/facebook.svg';
import LinkedinIcon from '../../../libraries/Icons/linkedin.svg';
import YoutubeIcon from '../../../libraries/Icons/youtube.svg';

const Footer = (props) => {
  const { translate, Intl } = props;

  const pages = [
    {
      name: translate('company_profile'),
      href: 'https://www.vision-net.co.jp/company/com_data.html?_ga=2.257714697.326346416.1709686574-110843729.1706243852&_gl=1*kiwlnu*_ga*MTEwODQzNzI5LjE3MDYyNDM4NTI.*_ga_TZ6TSGTBYC*MTcwOTY4NjU3NC40LjEuMTcwOTY4NjY0My41Ny4wLjA.'
    },
    {
      name: translate('handling_of_personal_information'),
      href: 'https://www.vision-net.co.jp/handling.html?_gl=1*tgcczm*_ga*MjA5MDM3ODA1MC4'
    },
    {
      name: translate('privacypolicy'),
      href: 'https://www.vision-net.co.jp/privacy.html?_ga=2.269240179.326346416.1709686574-110843729.1706243852&_gl=1*or96dp*_ga*MTEwODQzNzI5LjE3MDYyNDM4NTI.*_ga_TZ6TSGTBYC*MTcwOTY4NjU3NC40LjEuMTcwOTY4NjU3OS41NS4wLjA.'
    },
  ];
  const socials = [
    {
      name: "Facebook"
      , link: ""
      , icon: FacebookIcon
    },
    {
      name: "Linkedin"
      , link: ""
      , icon: LinkedinIcon
    },
    {
      name: "Youtube"
      , link: ""
      , icon: YoutubeIcon
    }
  ];

  return (
    <div className="footer">
      <Container maxWidth="xl">
        <Box sx={{ display: { xs: 'block', md: 'flex' }, gap: 10, py: 10 }}>
          <Box sx={{ textAlign: "left", maxWidth: "360px" }}>
            <Typography variant="h6" gutterBottom component="h6" sx={{ fontWeight: "500" }}>
              RPA CLOUD
            </Typography>
            <Typography variant="body1" gutterBottom component="p">
              {translate('introduceblog')}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "left" }}>
              {socials.map((social) => (
                <IconButton
                  key={social.name}
                  color="primary"
                  component="a"
                  target="_blank"
                  href={social.link}
                >
                  <img height="24px" src={social.icon} />
                </IconButton>
              ))}
            </Box>
          </Box>
          <Box sx={{ textAlign: "left" }}>
            <Typography variant="body1" gutterBottom component="p" sx={{ p: 1, textTransform: "uppercase" }}>
              {translate('resources')}
            </Typography>
            {pages.map((page) => (
                <LinkMui
                  underline="none"
                  key={page.name}
                  href={page.href}
                  sx={{ display: 'block', p: 1, color: "black" }}
                  target="_blank"
                >
                  {page.name}
                </LinkMui>
              ))}
          </Box>
        </Box>
        <Box sx={{ lineHeight: "40px", pb: 2 }}>
          Copyright © 2022 <strong>{ process.env.REACT_APP_COPYRIGHT }</strong>
        </Box>
      </Container>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    Intl: state.Intl,
  }
}

export default connect(mapStateToProps)(withTranslate(Footer));